import type { RadioData, RadioOption, Option, Options } from './types';

export const mapDataToOptions = (data: RadioData): Options =>
	data?.map(({ id, value }) => ({ label: value, value: id, testId: id }));

export const mapOptionToData = (option: Option): RadioOption => ({
	id: option?.value,
	value: option?.label,
});
